module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"percentage":"Porcentual increment %","fixed":"Fixed Increment €"},"es":{"percentage":"Incremento porcentual %","fixed":"Incremento fijo €"}}')
  delete Component.options._Ctor
}
